/**
 * The elevation of a card on the shell's tint: a hairline and a soft, even
 * fall-off on all four sides, so the card sits on the tint like a sheet with
 * weight.
 *
 * Every card beside the tabbed sidebar wears it: the page card, and Clu's
 * dock card, which stands in the page card's place beside the sidebar while
 * it is open. The fixed sidebar paints over that card's left side, so the
 * sidebar draws that side's shadow itself with this same class (see
 * TabsSidebar), and it matches whichever card is there.
 */
export const CARD_ELEVATION =
  'shadow-[0_0_0_1px_rgba(17,17,17,0.06),0_0_3px_rgba(17,17,17,0.08),0_0_14px_rgba(17,17,17,0.07)] dark:shadow-[0_0_0_1px_rgba(255,255,255,0.06),0_0_3px_rgba(0,0,0,0.4),0_0_14px_rgba(0,0,0,0.35)]';
